import * as React from "react";
import { QueryString, isString } from "@grandvisionhq/utils";
import { replaceStoreFinderUrlWithNewQueryParams } from "../../../../../../utils/utils/store-utils.js";
const useStoreFinderUrlParams = ({
  handleOnChange,
  setIsUserLocation,
  newQueryParams,
  enabled = false
}) => {
  const [initialSearchQuery, setInitialSearchQuery] = React.useState(void 0);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    const queryParams = QueryString.parse(window.location.search);
    const searchParam = queryParams.search;
    let search;
    if (isString(searchParam)) {
      search = searchParam;
    }
    const isUserLocation = queryParams.userLocation === "true";
    setIsUserLocation(isUserLocation);
    setInitialSearchQuery(search);
    if (search?.length && !isUserLocation) {
      handleOnChange(search);
    }
  }, [enabled]);
  React.useEffect(() => {
    if (enabled) {
      replaceStoreFinderUrlWithNewQueryParams(newQueryParams);
    }
  }, [enabled, newQueryParams]);
  return initialSearchQuery;
};
export {
  useStoreFinderUrlParams as default
};
//# sourceMappingURL=use-store-finder-url-params.js.map
